import {handleActions} from 'redux-actions'
import {LICENSE_COUNT_DAYS_TO_EXPIRATION} from './actionTypes'

const createLicenseCountDownTipReducer = ({
    LICENSE_COUNT_DOWN_TIP = null
}) => {
    const initialState = {
        ...LICENSE_COUNT_DOWN_TIP
    }

    return handleActions({
        [LICENSE_COUNT_DAYS_TO_EXPIRATION]: (state, {payload: licenseCountDaysToExpiration}) => ({
            ...state,
            licenseCountDaysToExpiration
        }),
    }, initialState)
}

export default createLicenseCountDownTipReducer


// WEBPACK FOOTER //
// ./web/js/components/licenseCountDownTip/reducer.js